import { FC, useEffect, useMemo, useState } from "react";
import { BillingsOrderRelatedTaxiTaxiItem } from "../../../../../../common/services/billings/order/related/taxi-taxi/billings-order-related-taxi-taxi";
import { useAppContext } from "../../../../../../context/app.context";
import useAbort from "../../../../../../common/hooks/use-abort";
import billingsTranslationsHelper from "../../../../../../languages/billings-translations.helper";
import CardComponent from "../../../../../../common/components/card/card.component";
import useBillingsOrderRelatedTaxiTaxi from "../../../../../../common/services/billings/order/related/taxi-taxi/use-billings-order-related-taxi-taxi";
import RelatedBillingsTaxiTaxiTableRow from "../../../../common/related-billings/taxi-taxi/types/related-billings-taxi-taxi-table-row";
import RelatedBillingsTaxiTaxiTableComponent from "../../../../common/related-billings/taxi-taxi/related-billings-taxi-taxi-table.component";
import relatedBillingsTaxiTaxiFactory from "./related-billings-taxi-taxi.factory";

type RelatedBillingsTaxiTaxiProps = {
  orderId: string | undefined;
};

const RelatedBillingsTaxiTaxiComponent: FC<RelatedBillingsTaxiTaxiProps> = (
  props,
) => {
  const translations =
    billingsTranslationsHelper.getBillingsTranslations().relatedBillings
      .taxi_taxi;

  const [relatedBillingsTaxiTaxiData, setRelatedBillingsTaxiTaxiData] =
    useState<BillingsOrderRelatedTaxiTaxiItem[]>([]);

  const { selectedAppLanguage } = useAppContext();
  const taxiTaxi = useBillingsOrderRelatedTaxiTaxi();
  const taxiTaxiAbort = useAbort();

  const taxiTaxiData = async () => {
    taxiTaxi.load({ orderUuid: props.orderId! }, taxiTaxiAbort.signal);
  };

  useEffect(() => {
    if (!props.orderId) return;

    taxiTaxiData();
  }, [props.orderId]);

  useEffect(() => {
    if (!taxiTaxi.data.data) return;

    setRelatedBillingsTaxiTaxiData(taxiTaxi.data.data);
  }, [taxiTaxi.data.data]);

  const tableRows: RelatedBillingsTaxiTaxiTableRow[] = useMemo(() => {
    if (!relatedBillingsTaxiTaxiData) return [];

    return relatedBillingsTaxiTaxiFactory.createTableRows(
      relatedBillingsTaxiTaxiData,
    );
  }, [relatedBillingsTaxiTaxiData, selectedAppLanguage]);

  return (
    <CardComponent
      classNames={{ root: "related_billings" }}
      header={{ title: translations.summaryLabel }}
    >
      <RelatedBillingsTaxiTaxiTableComponent
        tableRows={tableRows}
        isLoading={taxiTaxi.isLoading && !!props.orderId}
      />
    </CardComponent>
  );
};

export default RelatedBillingsTaxiTaxiComponent;
